import { atom } from "jotai";

import { Box, NavDesktopCategoryBar, NavMenuBar, getThemeValue } from "@theme/components";

import type { NavigationDataProps } from "@theme/types";
import type { FC } from "react";

/**
 * Nav Desktop Dropdown Open Atom
 *
 * Whether the Nav desktop dropdown is open
 * if open we need to darken the site based on designs
 */
export const navDesktopDropdownOpenAtom = atom(false);

/**
 * Drawer Open Atom
 *
 * Whether the mobile drawer is open or not.
 * this is needed for animating the super banner outside of Navigation scope.
 */
export const drawerOpenAtom = atom(false);

/**
 * Active Nav Dropdown Atom
 *
 * Which nav category index is currently active/open.
 * -1 means no category is open.
 */
export const activeNavDropdownAtom = atom<number>(-1);

interface NavigationProps {
  isCheckout?: boolean;
  navData: NavigationDataProps;
  hasSuperBanner?: boolean;
}

export const Navigation: FC<NavigationProps> = ({ isCheckout, navData, hasSuperBanner }) => (
  <Box
    as="header"
    sx={{
      position: "fixed",
      top: (t) => (hasSuperBanner ? getThemeValue(t, "sizes.superBannerHeight") : 0),
      width: "full",
      zIndex: 50,
    }}
  >
    <NavMenuBar navData={navData} isCheckout={isCheckout} />
    {!isCheckout && <NavDesktopCategoryBar navCategories={navData.siteNavData?.categories} />}
  </Box>
);
